export default {
  main: '#000000',
  secondary: '#EBC15B',
  contrastingColor: '#ffffff',
  priceColor: '#000000',
  entryBackground: '#ffffff',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
